var exports = {
  "$": "linkButton__rBg5F1",
};

module.exports = exports;
